export default function getEventKey(event) {
  return event.key;
}
